import * as actionTypes from "../actions/actionTypes";

export default function uploads(state = [], action) {
  switch (action.type) {
    case actionTypes.UPLOADS_DISMISS:
      return [];
    case actionTypes.ENQUEUE_UPLOAD: {
      return mergeNewUpload(state, action.actionToEnqueue, { status: "started" });
    }
    case actionTypes.INSERT_ASSET_ITEM:
    case actionTypes.CREATE_ITEM_ASSET:
    case actionTypes.REPLACE_ASSET_FILE:
    case actionTypes.INSERT_COLOR_ASSET_ITEM:
    case actionTypes.LARGE_FILE_UPLOAD_START: {
      return mergeNewUpload(state, action, {
        status: "started",
      });
    }
    case actionTypes.INSERT_ASSET_ITEM_SUCCESS:
    case actionTypes.CREATE_ITEM_ASSET_SUCCESS:
    case actionTypes.REPLACE_ASSET_FILE_SUCCESS:
    case actionTypes.INSERT_COLOR_ASSET_ITEM_SUCCESS:
    case actionTypes.INSERT_CHUNKED_ASSET_ITEM_SUCCESS: {
      const { entities, result } = action.response,
        item = entities.items?.[result],
        asset = entities.assets?.[result] ?? entities.assets?.[item?.assetId];

      const dateAddedStr = asset?.dateAdded ?? item?.dateAdded;
      return mergeNewUpload(state, action, {
        status: "success",
        dateAdded: dateAddedStr ? new Date(dateAddedStr) : undefined,
        spaceId: asset?.spaceId ?? item?.spaceId,
      });
    }
    case actionTypes.INSERT_ASSET_ITEM_FAILURE:
    case actionTypes.CREATE_ITEM_ASSET_FAILURE:
    case actionTypes.REPLACE_ASSET_FILE_FAILURE:
    case actionTypes.UPLOAD_FAILURE:
    case actionTypes.LARGE_FILE_UPLOAD_START_FAILURE:
    case actionTypes.LARGE_FILE_UPLOAD_CHUNK_FAILURE:
    case actionTypes.LARGE_FILE_UPLOAD_FINISH_FAILURE:
    case actionTypes.INSERT_COLOR_ASSET_ITEM_FAILURE:
    case actionTypes.INSERT_CHUNKED_ASSET_ITEM_FAILURE: {
      const { error } = action;
      return mergeNewUpload(state, action, {
        status: "failed",
        error,
      });
    }
    default:
      return state;
  }
}

function mergeNewUpload(state, action, extra = {}) {
  const {
    insertPosition: { kitId, spaceId } = {},
    upload: { id, name, type, size, error, asset },
  } = action;
  const i = state.findIndex(upl => upl.id === id);

  const newUpload = {
    id,
    name,
    type,
    size,
    kitId,
    spaceId,
    error,
    isAsset: (asset?.item?.type ?? "asset") === "asset",
    ...extra,
  };

  if (i >= 0) {
    const newState = [...state];
    newState.splice(i, 1, newUpload);
    return newState;
  } else return [...state, newUpload];
}
